import { useLocation } from "react-router-dom";
import { useState } from "react";
import ConnectModal from "./ConnectModal";

import st_wallet from "./WalletButton.module.css";
import WindowDimensions from "hooks/useDimensions";

const ConnectButton = () => {
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const isWeb = WindowDimensions();

    return (
        <>
        <button 
        className={!isWeb ? st_wallet.mobile_connect_btn: location.pathname === "/" ? 
        st_wallet.home_wallet_button : st_wallet.charity_wallet_button} 
        onClick={() => setOpen(true)}>Connect Wallet</button>
        <ConnectModal open={open} setOpen={setOpen}/>
        </>
    )
}

export default ConnectButton;